import React, { useState } from "react";
import Popup from "./PopupWithMessage";
import PhoneInput from "./../PhoneInput/PhoneInput";
import SelectInput from "../SelectInput/SelectInput";

const SendButton = ({ disabled }) => (
  <button type="submit" disabled={disabled} className="button popup-footer__button">Отправить</button>
);

const DoctorAbstractReviewPopup = ({ name, authenticity_token, doctors }) => {
  const [messageShown, setMessageShown] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [doctor, setDoctor] = useState('');
  const [formDisabled, setFormDisabled] = useState(false);
  const ordered_doctors = new Map(doctors);

  const hideMessage = () => setMessageShown(false);
  const toggleAgreement = () => setAgreed(!agreed);

  const handleSelectChanged = (doctor) => setDoctor(doctor);

  const handleSubmit = e => {
    e.preventDefault();

    setFormDisabled(true);

    const axios = require('axios');
    const url = '/reviews'
    const data = new FormData(e.target);

    axios
      .post(url, data, {headers: {'Accept': 'application/json'}})
      .then(() => setMessageShown(true))
      .finally(() => {
        setFormDisabled(false);
        setAgreed(false);
      })
  };

  return (
    <form onSubmit={handleSubmit} className="new_review" id="new_review" acceptCharset="UTF-8" method="post">
      <input name="utf8" type="hidden" value="✓" />
      <input type='hidden' name='authenticity_token' value={authenticity_token} />
      <Popup
        name={name}
        onHide={hideMessage}
        header="Оставить отзыв"
        footer={<SendButton disabled={formDisabled || !agreed}/>}
        message="Спасибо за отзыв!"
        messageShown={messageShown}
        hideMessage={hideMessage}
      >
        <div className="popup-form">
          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="review_fullname">Ваше имя</label>
            <input id="review_fullname" className="input-group__input" required name='review[fullname]' />
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="review_email">Электронная почта</label>
            <input id="review_email" className="input-group__input" name='review[email]' type="email" />
            <div className="input-group__hint">
              Личные данные не будут отражены при публикации отзыва на сайте.
            </div>
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" >Специалист</label>
            <SelectInput options={ordered_doctors} onSelectChanged={handleSelectChanged} />
          </div>

          <input className="hidden" name='review[reviewable_type]' value="Doctor" type="hidden" />
          <input className="hidden" name='review[reviewable_id]' value={doctor} type="hidden" />

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="review_body">Отзыв</label>
            <textarea id="review_body" className="input-group__textarea" required name='review[body]' />
          </div>

          <div className="input-group">
            <label className="input-group__label input-group__label_checkbox">
              <input type="checkbox" onClick={toggleAgreement} className="input-group__checkbox" required />
              <div className="input-group__checkbox-state" />
              Выражаю согласие на обработку персональных данных в соответствии
              с условиями.
            </label>
          </div>
        </div>
      </Popup>
    </form>
  );
};

export default DoctorAbstractReviewPopup;
